// eslint-disable-next-line import/no-cycle
import { FragmentConfig } from './types';

/* eslint-disable prefer-destructuring */
const FRAGMENT_COMPANYID = process.env.FRAGMENT_COMPANYID || 'imwalkingde';
const FRAGMENT_HOST = process.env.FRAGMENT_HOST || 'emma.lan';
const FRAGMENT_NAMESPACE = process.env.FRAGMENT_NAMESPACE || 'fragment-inspire-footer';
const FRAGMENT_NAMESPACE_URL = process.env.FRAGMENT_NAMESPACE_URL || 'fragment-inspire-footer';
const NODE_ENV = process.env.NODE_ENV || '';
const BRANCH = process.env.BRANCH || 'master';
const CLUSTER_ENV = process.env.CLUSTER_ENV || 'production';
const DISABLE_LEGACY = process.env.DISABLE_LEGACY || 'false';
const isDisableLegacy = !!(DISABLE_LEGACY && DISABLE_LEGACY === 'true');
const confApiHost = `cms.${FRAGMENT_HOST}`;
const replacePage = '::PAGE::';

const config: FragmentConfig = {
  global: {
    enabled: true,
    values: {
      FRAGMENT_HOST,
      FRAGMENT_COMPANYID,
      FRAGMENT_NAMESPACE,
      FRAGMENT_NAMESPACE_URL,
      NODE_ENV,
      BRANCH,
      CLUSTER_ENV,
      EPRIVACY_ENABLED: false,
      DISABLE_LEGACY: isDisableLegacy,
    },
  },
  apiParams: {
    enabled: true,
    values: {
      apiDefaultParams: {
        channel: 'web',
        clientId: 'ImWalkingDe',
        clientShortId: 'iaw',
        locale: 'de-DE',
        localeApi: 'de',
        localesToSwitch: [],
        useNewApi: true,
      },
      apiAssetManagement: {
        path: 'https://media.imwalking.de',
      },
      apiRecoMagellan:
        '/suche/reco/magellan?clientId={REPLACE_CLIENTID}&type=WEIKATEC&datatype=json&maxCnt={REPLACE_MAX_COUNT}&filterValues=&locale={REPLACE_LOCALE_ISO}&method=CATEGORY&shopID={REPLACE_SHOP_ID}',
      apiRecoPrudsys:
        '/INTERSHOP/rest/WFS/EmpirieCom-{REPLACE_CLIENTID}-Site/web;loc={REPLACE_LOCALE_ISO};cur=EUR/fwd/ps40/{REPLACE_CLIENT_SHORT_ID}/plugins/exec/prudsys/prudsys/core/recommendation/{REPLACE_TYPE}?sid={REPLACE_SID}&locationid={REPLACE_LOCATION_ID}&userid={REPLACE_USER_ID}&tracking=true&cid={REPLACE_SHOP_ID}',
      apiCampaignEndPoint:
        'INTERSHOP/web/WFS/EmpirieCom-ImwalkingDE-Site/de_DE/web/EUR/PromotionNotification-Put',
    },
  },
  fetchParams: {
    enabled: true,
    values: {
      timeout: 5000,
      timeoutFallback: 10000,
    },
  },
  esiUrls: {
    enabled: true,
    values: {
      fragmentCommon: `http://fragment-common.${FRAGMENT_HOST}/`,
    },
  },
  mediaBreakpoints: {
    enabled: true,
    values: {
      desktopMinWidth: '1025px',
      tabletMinWidth: '481px',
      tabletMaxWidth: '1024px',
      mobileMaxWidth: '480px',
    },
  },
  replace: {
    enabled: true,
    values: {
      page: replacePage,
    },
  },
  currency: { sign: 'EUR', locale: 'de-DE' },
  apiCmsUrl: {
    enabled: true,
    environmentRelated: true,
    values: {
      url: `https://${confApiHost}/<localeApi>${replacePage}?_format=webapp_json&flat`,
      endPoint: '/footer',
    },
  },
  apiCmsUrlStaticPages: {
    enabled: true,
    environmentRelated: true,
    values: {
      url: '/api/inspire/pages/<localeApi>/<page>.json',
    },
  },
  apiCmsUrlFallback: {
    enabled: true,
    environmentRelated: true,
    values: {
      url: `https://${FRAGMENT_HOST}/fragment-inspire-footer/static-bucket/${FRAGMENT_COMPANYID}/<localeApi>${replacePage}.json`,
    },
  },
  apiCmsUrlPrefix: {
    enabled: true,
    environmentRelated: true,
    values: {
      url: `https://${confApiHost}`,
    },
  },
  footer: {
    listBlock: {
      defaultIcon: 'Checkmark',
    },
  },
};

export default config;
